import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Table from "../../Table";
import {
  deleteCart,
  fetchAllCarts,
} from "../../../../redux/reducer/cartReducer";
import DetailsCartTable from "./DetailsCartTable";
import LoadingSpinner from "../../../animation/LoadingSpinner";
import BoxEmpty from "../../../boxDetials/boxEmpty";

const PendingCart = () => {
  const [editingOrder, setEditingOrder] = useState(null);
  const [editingProducts, setEditingProducts] = useState(null);
  const dispatch = useDispatch();
  const { allCarts, loading, error } = useSelector((state) => state.carts);
  const { t } = useTranslation();
  const [searchBox, setSearchBox] = useState("");
  // console.log(allCarts)
  const headers = [
    "ID",
    "Box. No",
    "Name",
    "Phone",
    "Status",
    // 'Notes',
    "Created At",
    "Actions",
    "Products",
  ];

  const refreshData = () => {
    dispatch(fetchAllCarts(["pending"]));
  };

  useEffect(() => {
    dispatch(fetchAllCarts(["pending"]));
  }, [dispatch]);

  const handleDelete = (cartId) => {
    if (window.confirm("Are you sure you want to delete this Cart?")) {
      dispatch(deleteCart(cartId))
        .unwrap()
        .then(() => {
          dispatch(fetchAllCarts(["pending"]));
        })
        .catch((error) => alert(error || "Failed to delete Cart."));
    }
  };

  const handleUpdate = () => {
    dispatch(fetchAllCarts(["pending"]));
  };
  const pendingCartsBefore = allCarts?.filter(
    (cart) => cart?.status === "pending"
  );
  // console.log(allCarts)
  const pendingCarts = allCarts
    ?.filter((cart) => cart.status === "pending")
    .filter((cart) =>
      cart.referenceCode?.toLowerCase().includes(searchBox.toLowerCase())
    );

  // console.log(pendingCarts)

  if (loading && pendingCartsBefore.length === 0) {
    return <LoadingSpinner />;
  }

  if (pendingCartsBefore.length === 0) {
    return <BoxEmpty title="Not Found Orders" />;
  }
  return (
    <Table
      title={t("Orders Placed")}
      headers={headers}
      data={pendingCarts}
      searchBox={searchBox}
      setSearchBox={setSearchBox}
      renderRow={(cart, index) => (
        <DetailsCartTable
          key={cart._id || index}
          index={index + 1}
          details={{
            id: cart._id,
            number: index + 1,
            boxNumber: cart.referenceCode,
            Name: cart.user?.name,
            phone: cart.user?.phone,
            countryCode: cart.user?.countryCode,
            status: cart.status,
            note: cart.notesAdmin,
            history: cart.createdAt,
            products: cart.products,
          }}
          isEditing={editingOrder === cart._id}
          setEditingOrder={setEditingOrder}
          isProducts={editingProducts === cart._id}
          setEditingProducts={setEditingProducts}
          onDelete={() => handleDelete(cart._id)}
          onUpdate={handleUpdate}
          refreshData={refreshData}
          loading={loading}
        />
      )}
    />
  );
};

export default PendingCart;
